/* CUSTOM: Hide (D#...) IDs in Ajax Drawer - Ty Dec 8 2025*/
(function() {
    // 1. Define the cleaner function
    function cleanDrawerIDs() {
        // Target the specific class you mentioned
        jQuery('.ajaxcart__product-meta').each(function() {
            var text = jQuery(this).text();
            
            // Check if it contains the D# ID
            if (text && text.indexOf('(D#') !== -1) {
                // Regex explains: Find optional space \s?, then (D#, then any characters until ), then )
                var newText = text.replace(/\s?\(D#[^)]+\)/g, '');
                
                // Only update if we actually changed something to avoid infinite loops
                if (text !== newText) {
                    jQuery(this).text(newText);
                }
            }
        });
    }

    // 2. Setup a watcher (MutationObserver) to detect when the drawer opens/updates
    var observer = new MutationObserver(function(mutations) {
        // When the DOM changes, try to clean the IDs
        cleanDrawerIDs();
    });

    // 3. Start watching the body for added elements (like the drawer)
    var config = { childList: true, subtree: true };
    observer.observe(document.body, config);
})();